export default __webpack_public_path__ + "static/media/more_horiz.b450d813.svg";